<script>
  import { afterUpdate } from "svelte"

  export let json
  let count = 0
  afterUpdate(() => {
    count = json.email.split(",").length - 1
  })
  // console.log(count)
</script>

<div>
  <div class="mx-auto mt-3 flex h-full w-full flex-col rounded-md bg-[#f7f7f7] px-6 py-3 hover:shadow-md dark:border-2 dark:border-transparent dark:bg-lightgray dark:hover:border-blue-500">
    <div class="flex w-full flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
      <div class="w-full space-y-1.5 md:w-1/2">
        <div class="flex w-full items-center gap-0 mobile:gap-3">
          <div data-tooltip={json.status} tooltip-position="top" class="flex items-center justify-center rounded-full">
            <div class="relative hidden h-9 w-9 mobile:block">
              <div class="absolute -top-1 -right-1 h-3 w-3 rounded-full border border-white {json.status == 'SENT' ? 'bg-[#ff6a00]' : json.status == 'BOUNCED' ? 'bg-red-500' : json.status == 'DELIVERED' ? 'bg-green-500' : 'bg-sky-500'}" />
              <i class="fa-solid fa-envelope fa-2x text-zinc-900 dark:text-gray-500" />
            </div>
          </div>
          <div class="w-full space-y-2 mobile:space-y-1.5">
            <p class="{json.status == 'SENT' ? 'text-[#ff6a00]' : json.status == 'BOUNCED' ? 'text-red-500' : json.status == 'DELIVERED' ? 'text-green-500' : 'text-sky-500'} block text-xs font-semibold mobile:hidden">{json.status}</p>

            <div class="hidden w-full items-center text-xs font-semibold text-gray-800 dark:text-blue-300 mobile:flex sm:text-base">
              <p title={!count ? json.email : json.email.split(",")[0]}>{!count ? json.email : json.email.split(",")[0]}</p>
              <div class="group relative">
                <p class="cursor-pointer">{count ? `, +${count}` : ``}</p>
                <div class="absolute left-3 top-5 z-10 hidden max-h-[290px] space-y-2 overflow-auto rounded-md bg-bodyblack px-4 py-3 text-sm font-medium text-gray-400 group-hover:block">
                  {#each json.email.split(",") as email, i}
                    <div class="flex items-center gap-1">
                      <p class="w-5 text-white">{i == 0 ? "to:" : ""}</p>
                      <p>{email}</p>
                    </div>
                  {/each}
                </div>
              </div>
            </div>

            <p class="block w-auto truncate text-xs font-semibold text-gray-800 dark:text-blue-300 mobile:hidden sm:text-base">
              <i class="fa-solid fa-envelope fa-lg" />
              &nbsp;
              {!count ? json.email : json.email.split(",")[0]}{count ? `, +${count}` : ``}
            </p>

            <p class="font hidden select-none text-xs font-normal text-gray-200 mobile:block sm:text-sm">
              {new Date(json.date).toString().slice(0, 24)}
            </p>
            <p class="font block select-none text-xs font-normal text-gray-200 mobile:hidden sm:text-sm">
              <i class="fa-solid fa-calendar-days fa-lg" />
              &nbsp; {new Date(json.date).toString().slice(0, 24)}
            </p>
          </div>
        </div>
      </div>
      <div class="w-full space-y-2 mobile:space-y-1.5 sm:w-1/2">
        <p class="w-auto truncate text-xs font-medium text-gray-800 disabled:text-gray-500 dark:text-gray-400 sm:text-sm">
          <!-- <i class="fa-solid fa-file-excel" /> -->
          <strong class="select-none">Request ID</strong>
          &nbsp;
          {json.messageID}
        </p>
        <p class="w-auto truncate text-xs font-medium text-gray-800 dark:text-gray-400 sm:text-sm">
          <!-- <i class="fa-solid fa-circle-plus text-yellow-400" /> -->
          <strong class="select-none">Tag</strong>
          &nbsp;
          {json.tag}
        </p>
      </div>
    </div>
  </div>
</div>
